export default __webpack_public_path__ + "static/media/avatar_47.d7949a41.png";